import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "../../lib/cx";
import styles from "./Badge.module.css";

export type BadgeVariant = "neutral" | "accent" | "warn" | "success";

export type BadgeProps = {
  variant?: BadgeVariant;
  children: ReactNode;
} & HTMLAttributes<HTMLSpanElement>;

export const Badge = ({ variant = "neutral", className, children, ...rest }: BadgeProps) => (
  <span data-variant={variant} className={cx(styles.badge, className)} {...rest}>
    {children}
  </span>
);
